
import './App.css';
import React, { useEffect, useState } from "react";
import LandingPage from './Pages/LandingPage';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import SideMenu from './SideMenu/SideMenu';
import { I18nextProvider } from 'react-i18next';
import { CacheProvider } from '@emotion/react';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import { Box } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import i18next from "i18next";
import Context from "./assets/js/context";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/test1.css";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { setUserToken } from "./reduxStore/UserReducer";
import { setscreenwidth } from "./reduxStore/SettingsReducer";
import { Slide } from "react-toastify";
import ProviderRedirect from './Components/ProviderRedirect';
import Welcome from './Pages/Welcome/Welcome';
import SessionEnd from './Pages/SessionEnd';
import SorryPage from './Pages/SorryPage';
import PageNotFound from './Pages/PageNotFound';
import SessionKeepAlive from './Components/SessionKeepAlive';
import DynamicFields from './Pages/DynamicFields/DynamicFields';
import GeoExtractor from './Pages/GeoExtractor/GeoExtractor';
import Profile from './Pages/Progfile/Profile';

const cookies = new Cookies();

function App() {

  const [state] = useState({
    data: [],
    ms: [],
    data1: [],
    Dash: [],
    check: "",
    che: "login",
    new: "",
    inprogress: "",
    closed: "",
    approved: "",
    rejected: "",
    archived: "",
    noti: "",
    desc: "",
    commenter: "",
    body: "",
    title: "",
    SiFilter: [],
  });

  const directions = useSelector((state) => state.settingsData.directions);
  const languageCode = useSelector((state) => state.settingsData.code);

  const Translate_ar = useSelector(
    (state) => state.translateData.translation_ar
  );
  const Translate_en = useSelector(
    (state) => state.translateData.translation_en
  );
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const dispatch = useDispatch();
  const token = cookies.get("token");

  useEffect(() => {
    if (token) {
      dispatch(setUserToken(token));
    }
  }, [token, dispatch]);

  const [theme, setTheme] = useState(
    createTheme({
      direction: directions, // Both here and <body dir="rtl">
    })
  );

  useEffect(() => {
    if (i18next.isInitialized) {
      i18next.changeLanguage(languageCode);
    }
  }, [languageCode]);

  try {
    const bodyWeb = document.querySelector("body");
    if (bodyWeb) {
      bodyWeb.style.background = maintheme?.background;
    }

    if (!i18next.isInitialized) {
      i18next.init({
        interpolation: { escapeValue: false },
        lng: languageCode,
        resources: {
          ar: { common: Translate_ar },
          en: { common: Translate_en },
        },
      });
    }
  } catch (error) {
    console.log(error?.message);
  }

  useEffect(() => {
    localStorage.setItem("direction", directions);
    if (directions === "rtl") {
      document.dir = "rtl";
      const htmlTag = document.querySelector("html");
      if (htmlTag) {
        htmlTag.lang = "ar";
      }
      cookies.set("language", "ar");
    } else {
      document.dir = "ltr";
      cookies.set("language", "en");
    }

    setTheme(
      createTheme({
        direction: directions, // Both here and <body dir="rtl">
      })
    );
  }, [directions]);

  const isrtl = React.useMemo(() => {
    return createCache({
      key: directions === "rtl" ? "muirtl" : "muiltr",
      stylisPlugins: directions === "rtl" ? [rtlPlugin] : [],
    });
  }, [directions]);

  useEffect(() => {
    const handleResize = () => {
      dispatch(setscreenwidth(window.innerWidth));
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <I18nextProvider i18n={i18next}>
        <CacheProvider value={isrtl}>
          <ThemeProvider theme={theme}>
            <BrowserRouter>
              {/* Session Keep-Alive Component - Runs in background (must be inside BrowserRouter) */}
              <SessionKeepAlive />

              <ToastContainer
                containerId="container_toast_id"
                position="top-center"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={false}
                transition={Slide}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              <Context.Provider
                value={{
                  value: state,
                  action: {},
                }}
              >
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path='/system' element={<SideMenu />}>
                    <Route
                      path={"welcome"}
                      element={<React.Suspense fallback={<LandingPage />}>
                        <ProviderRedirect><Welcome /></ProviderRedirect>
                      </React.Suspense>}
                    />
                    <Route
                      path={"dynamic-fields"}
                      element={<React.Suspense fallback={<LandingPage />}>
                        <ProviderRedirect><DynamicFields /></ProviderRedirect>
                      </React.Suspense>}
                    />
                    <Route
                      path={"geo-extractor"}
                      element={<React.Suspense fallback={<LandingPage />}>
                        <ProviderRedirect><GeoExtractor /></ProviderRedirect>
                      </React.Suspense>}
                    />
                    <Route
                      path={"profile"}
                      element={<React.Suspense fallback={<LandingPage />}>
                        <ProviderRedirect><Profile /></ProviderRedirect>
                      </React.Suspense>}
                    />

                  </Route>
                  <Route path='/redirect' element={<SessionEnd />} />
                  <Route path='/sorry' element={<SorryPage />} />
                  <Route path="*" element={<PageNotFound />} />

                </Routes>
              </Context.Provider>
            </BrowserRouter>
          </ThemeProvider>
        </CacheProvider>
      </I18nextProvider>
    </Box>
  )

}

export default App;
